import React, { Component } from 'react';
import { isNumerical, formatThousands } from '../../util';

class NumericalInput extends Component {

  handleChange(e){
    const newValue = e.target.value;
    let newValueWithoutCommas = newValue.replace(/,/g, '');

    //numerical only
    if(newValueWithoutCommas !== '' && !isNumerical(newValueWithoutCommas)){
      return;
    }

    //parse int if set
    if(newValueWithoutCommas !== ''){
      newValueWithoutCommas = parseInt(newValueWithoutCommas);
    }

    this.props.onUpdate(newValueWithoutCommas);
  }

  getFormattedValue(){

    const valueToFormat = (this.props.value !== '' && this.props.value !== undefined) ? this.props.value : '';

    if(this.props.formatThousands){
      return formatThousands(valueToFormat);
    }
    else{
      return valueToFormat;
    }
  }

  hasValue(){
    return this.props.value !== '' && this.props.value !== undefined;
  }

  render(){
    return (
      <input
        ref={input => { if(typeof this.props.inputRef === 'function'){ this.props.inputRef(input); } } }
        type="text"
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        className={`${this.props.className} ${this.hasValue() ? 'has-value' : ''}`}
        value={this.getFormattedValue()}
        onChange={this.handleChange.bind(this)}
        onBlur={this.props.onBlur}
        />
    );
  }
}

export default NumericalInput;



// WEBPACK FOOTER //
// ./src/components/shared/numericalInput.js